/**
 * Paginação no cliente, para as listagens cujo endpoint devolve o conjunto completo.
 *
 * Vale a pena dizer quando isto é legítimo: só quando a tela tem **todos** os itens em mãos.
 * Aplicar isto sobre uma página vinda do servidor daria a ilusão de paginar duas vezes, e o
 * filtro passaria a filtrar só o pedaço carregado — o engano clássico.
 *
 * Conexões, API e Elegibilidade usam; Convites, Transações, Histórico e a árvore de escopo
 * paginam no servidor e não passam por aqui.
 */

/** A página pedida. Página é 1-based, como o paginador do dashboard. */
export const pageOf = <T>(rows: T[], page: number, size: number): T[] =>
  rows.slice((page - 1) * size, page * size);

/**
 * A página válida mais próxima.
 *
 * Trocar o filtro pode deixar a página corrente fora do resultado, e uma tabela vazia com
 * paginador cheio parece defeito. Quem filtra volta para a primeira; quem revoga o último
 * item de uma página recua uma.
 */
export const clampPage = (page: number, total: number, size: number): number => {
  const pages = Math.max(1, Math.ceil(total / size));

  return Math.min(Math.max(1, page), pages);
};

/**
 * Texto da contagem ao lado dos filtros.
 *
 * Filtro sem contagem esconde o próprio efeito: pouca linha na tela pode ser pouca coisa, ou
 * corte do filtro.
 */
export const countLabel = (shown: number, total: number, noun: string, of: string): string =>
  shown === total ? `${total} ${noun}` : `${shown} ${of} ${total} ${noun}`;
